import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Category, Partner, MenuItem } from '../models/models';

@Injectable({
    providedIn: 'root'
})
export class MockDataService {

    private categories: Category[] = [
        { id: '1', name: 'Restaurantes', icon: 'restaurant', color: '#FADFA1' }, // Yellow/Orange
        { id: '2', name: 'Tiendas', icon: 'storefront', color: '#C9E4CA' }, // Green
        { id: '3', name: 'Comida a domicilio', icon: 'delivery_dining', color: '#F0E68C' }, // Yellow
        { id: '4', name: 'Medicina1', icon: 'medication', color: '#E6E6FA' }, // Light Purple
        { id: '5', name: 'Vivienda', icon: 'cottage', color: '#E0F2F1' }, // Teal/Mint
        //{ id: '5', name: 'Farmacia', icon: 'medication', color: '#D3D3D3' }, // Grey/Green
        //{ id: '6', name: 'Hogar', icon: 'cottage', color: '#FFDEAD' }, // Peach
        //{ id: '7', name: 'Mi&A', icon: 'pets', color: '#F4A460' }, // Orange/Brown (Pet supplies?)
        //{ id: '8', name: 'Más', icon: 'more_horiz', color: '#F5DEB3' } // Wheat
    ];

    private partners: Partner[] = [
        {
            id: 'masmanzana',
            nameid: 'masmanzana',
            componenttype: 'shop',
            name: 'Mas Manzana',
            city: 'Algodonales',
            rating: 4.5,
            deliveryTime: '20-30 min',
            deliveryFee: 1.99,
            imageUrl: 'https://images.unsplash.com/photo-1571091718767-18b5b1457add?w=800&q=80',
            categories: ['Burgers', 'American'],
            hasDelivery: true,
            categoriesId: ['2'],
            address: 'Av. de la Feria, 14, 11650 Villamartín, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Locura+Villamartin',
            coordinates: { lat: 36.8617, lng: -5.6444 },
            menu: [
                { id: 'm1', name: 'Tapa arterias', description: 'Flame-grilled beef patty, topped with tomatoes, cut lettuce, mayo, pickles, a swirl of ketchup, and sliced white onions on a soft sesame seed bun.', price: 9.50, imageUrl: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=500&q=80', categoryId: '1', popular: true, menuSection: 'Hamburguesas', isAvailable: true },
                { id: 'm2', name: 'Cheeseburger', description: 'A classic cheeseburger with a signature flame-grilled beef patty.', price: 4.50, imageUrl: 'https://images.unsplash.com/photo-1550547660-d9450f859349?w=500&q=80', categoryId: '1', menuSection: 'Hamburguesas', isAvailable: true },
                { id: 'm1_3', name: 'Alitas de Pollo', description: '6 alitas crujientes con salsa barbacoa.', price: 5.50, imageUrl: 'https://images.unsplash.com/photo-1567620832903-9fc6debc209f?w=500&q=80', categoryId: '1', menuSection: 'Entrantes', isAvailable: true },
                { id: 'm1_4', name: 'Refresco Cola', description: 'Lata 33cl.', price: 1.50, imageUrl: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?w=500&q=80', categoryId: '1', menuSection: 'Bebidas', isAvailable: true }
            ]
        },
        {
            id: 'locura',
            nameid: 'locura',
            componenttype: 'delivery',
            name: 'Locura',
            city: 'Villamartin',
            rating: 4.5,
            deliveryTime: '20-30 min',
            deliveryFee: 1.99,
            imageUrl: 'https://images.unsplash.com/photo-1571091718767-18b5b1457add?w=800&q=80',
            categories: ['Burgers', 'American'],
            hasDelivery: true,
            categoriesId: ['1'],
            address: 'Av. de la Feria, 14, 11650 Villamartín, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Locura+Villamartin',
            coordinates: { lat: 36.8617, lng: -5.6444 },
            menu: [
                { id: 'm1', name: 'Tapa arterias', description: 'Flame-grilled beef patty, topped with tomatoes, cut lettuce, mayo, pickles, a swirl of ketchup, and sliced white onions on a soft sesame seed bun.', price: 9.50, imageUrl: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=500&q=80', categoryId: '1', popular: true, menuSection: 'Hamburguesas', isAvailable: true },
                { id: 'm2', name: 'Cheeseburger', description: 'A classic cheeseburger with a signature flame-grilled beef patty.', price: 4.50, imageUrl: 'https://images.unsplash.com/photo-1550547660-d9450f859349?w=500&q=80', categoryId: '1', menuSection: 'Hamburguesas', isAvailable: true },
                { id: 'm1_3', name: 'Alitas de Pollo', description: '6 alitas crujientes con salsa barbacoa.', price: 5.50, imageUrl: 'https://images.unsplash.com/photo-1567620832903-9fc6debc209f?w=500&q=80', categoryId: '1', menuSection: 'Entrantes', isAvailable: true },
                { id: 'm1_4', name: 'Refresco Cola', description: 'Lata 33cl.', price: 1.50, imageUrl: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?w=500&q=80', categoryId: '1', menuSection: 'Bebidas', isAvailable: true }
            ]
        },
        {
            id: 'gallo',
            componenttype: 'delivery',
            nameid: 'pizzaskikiriki',
            name: 'Pizzas Kikiriki',
            city: 'Algodonales',
            rating: 4.2,
            deliveryTime: '30-45 min',
            deliveryFee: 2.49,
            imageUrl: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=800&q=80',
            categories: ['Pizza', 'Italian'],
            hasDelivery: true,
            categoriesId: ['3'],
            address: 'C. Arcos, 36, 11680 Algodonales, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Pizzas+Kikiriki+Algodonales',
            coordinates: { lat: 36.8795, lng: -5.4055 },
            menu: [
                { id: 'm3', name: 'Pepperoni Lover\'s', description: 'Double pepperoni and extra mozzarella cheese.', price: 12.99, imageUrl: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=500&q=80', categoryId: '2', popular: true, menuSection: 'Pizzas', isAvailable: true },
                { id: 'm4', name: 'Margherita', description: 'Classic tomato sauce, mozzarella cheese, and fresh basil.', price: 9.99, imageUrl: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&q=80', categoryId: '2', menuSection: 'Pizzas', isAvailable: true },
                { id: 'm2_3', name: 'Pan de Ajo', description: 'Pan tostado con mantequilla de ajo y perejil.', price: 3.50, imageUrl: 'https://images.unsplash.com/photo-1573140247632-f846ae0182ce?w=500&q=80', categoryId: '2', menuSection: 'Entrantes', isAvailable: true },
                { id: 'm2_4', name: 'Tiramisú', description: 'Postre casero italiano.', price: 4.50, imageUrl: 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=500&q=80', categoryId: '2', menuSection: 'Postres', isAvailable: true }
            ]
        },
        {
            id: 'freiduria',
            componenttype: 'delivery',
            nameid: 'freiduria',
            name: 'Freiduria',
            city: 'Ronda',
            rating: 4.8,
            deliveryTime: '40-50 min',
            deliveryFee: 3.99,
            imageUrl: 'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?w=800&q=80',
            categories: ['Sushi', 'Japanese'],
            hasDelivery: true,
            categoriesId: ['3'],
            address: 'C. la Bola, 12, 29400 Ronda, Málaga',
            googleMapsUrl: 'https://maps.google.com/?q=Freiduria+Ronda',
            coordinates: { lat: 36.7462, lng: -5.1612 },
            menu: [
                { id: 'bb1', name: 'Original Glazed', description: 'Nuestra dona más icónica.', price: 1.5, imageUrl: 'https://images.unsplash.com/photo-1551024601-bec78aea704b?auto=format&fit=crop&w=400', menuSection: 'Donas', isAvailable: true },
                { id: 'bb2', name: 'Chocolate Iced', description: 'Rellena con chocolate belga.', price: 1.8, imageUrl: 'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?auto=format&fit=crop&w=400', menuSection: 'Donas', isAvailable: true },
                { id: 'r3_3', name: 'Café Latte', description: 'Espresso con leche cremada.', price: 2.20, imageUrl: 'https://images.unsplash.com/photo-1541167760496-1628856ab772?w=500&q=80', menuSection: 'Bebidas', isAvailable: true }
            ]
        },
        {
            id: 'nogalbakery',
            componenttype: 'shop',
            nameid: 'nogalbakery',
            name: 'Nogal Bakery',
            city: 'Olvera',
            rating: 4.9,
            deliveryTime: '',
            deliveryFee: 1.5,
            imageUrl: 'https://s1.abcstatics.com/media/gurme/2023/09/21/v/nogalbakeryolverasalva-k9FG--1248x698@abc.jpg',
            categories: ['Panadería', 'Artesano', 'Desayuno'],
            isFeatured: true,
            hasDelivery: false,
            categoriesId: ['2'],
            address: 'C. Llana, 5, 11690 Olvera, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Nogal+Bakery+Olvera',
            coordinates: { lat: 36.9328, lng: -5.2530 },
            menu: [
                {
                    id: 'p1',
                    name: 'Maiz y Chia',
                    description: 'Hogaza artesana de 500g elaborada con masa madre.',
                    price: 2.10,
                    imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbCmTdlpVFaxajxSUtnxLeOu_8M5Ln4dHQzQ&s',
                    isReservable: true,
                    menuSection: 'Panes',
                    isAvailable: true
                },
                {
                    id: 'p2',
                    name: 'Baguette Tradición',
                    description: 'Clásica baguette francesa con corteza crujiente.',
                    price: 1.20,
                    imageUrl: 'https://images.unsplash.com/photo-1597079910443-60c43fc4f729?auto=format&fit=crop&w=400',
                    isReservable: true,
                    menuSection: 'Panes',
                    isAvailable: true
                },
                {
                    id: 'p3',
                    name: 'Integral Multi-cereales',
                    description: 'Pan rico en fibra con semillas de sésamo y lino.',
                    price: 2.50,
                    imageUrl: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=400',
                    isReservable: true,
                    menuSection: 'Panes',
                    isAvailable: true
                },
                {
                    id: 'd1',
                    name: 'Croissant Mantequilla',
                    description: 'Hojaldre 100% mantequilla pura.',
                    price: 1.60,
                    imageUrl: 'https://images.unsplash.com/photo-1555507036-ab1f4038808a?auto=format&fit=crop&w=400',
                    menuSection: 'Bollería',
                    isAvailable: true
                },
                {
                    id: 'd2',
                    name: 'Napolitana de Chocolate',
                    description: 'Rellena con doble crema de chocolate.',
                    price: 1.90,
                    imageUrl: 'https://images.unsplash.com/photo-1530610476181-d83430b64dcd?auto=format&fit=crop&w=400',
                    menuSection: 'Bollería',
                    isAvailable: true
                },
                { id: 'b_drink1', name: 'Zumo de Naranja', description: 'Recién exprimido.', price: 2.50, imageUrl: 'https://images.unsplash.com/photo-1613478223719-2ab802602423?w=500&q=80', menuSection: 'Bebidas', isAvailable: true }
            ]
        },
        {
            id: 'tacobell',
            componenttype: 'delivery',
            nameid: 'tacobell',
            name: 'Taco Bell',
            city: 'Algodonales',
            rating: 4.1,
            deliveryTime: '15-25 min',
            deliveryFee: 1.49,
            imageUrl: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=800&q=80',
            categories: ['Tacos', 'Mexican'],
            hasDelivery: true,
            categoriesId: ['3'],
            address: 'Av. de la Constitución, 45, 11680 Algodonales, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Taco+Bell+Algodonales',
            coordinates: { lat: 36.8790, lng: -5.4050 },
            menu: [
                { id: 'm7', name: 'Crunchy Taco Supreme', description: 'A crunchy corn taco shell filled with seasoned beef, lettuce, and cheese.', price: 2.99, imageUrl: 'https://www.tacobell.co.uk/wp-content/uploads/2021/04/CrunchyTacoSupreme-1370x650px.jpg', categoryId: '7', popular: true, menuSection: 'Tacos', isAvailable: true },
                { id: 'm7_2', name: 'Nachos Supreme', description: 'Con queso, guacamole y crema agria.', price: 4.99, imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFFWK7fOpSNxO12en30gJgR04fVTr4wDBRVw&s', categoryId: '7', menuSection: 'Complementos', isAvailable: true }
            ]
        },
        {
            id: 'r5',
            componenttype: 'delivery',
            nameid: 'saladstop1',
            name: 'Salad Stop1',
            city: 'Algodonales',
            rating: 4.6,
            deliveryTime: '25-35 min',
            deliveryFee: 1.99,
            imageUrl: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&q=80',
            categories: ['Healthy', 'Salad'],
            hasDelivery: true,
            categoriesId: ['3'],
            address: 'C. Ronda, 22, 11680 Algodonales, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Salad+Stop1+Algodonales',
            coordinates: { lat: 36.8785, lng: -5.4045 },
            menu: [
                { id: 'm8', name: 'Caesar Salad', description: 'Romaine lettuce, croutons, parmesan cheese, and caesar dressing.', price: 8.99, imageUrl: 'https://images.unsplash.com/photo-1550304943-4f24f54ddde9?w=500&q=80', categoryId: '6', menuSection: 'Ensaladas', isAvailable: true },
                { id: 'm8_2', name: 'Agua Mineral', description: '500ml', price: 1.20, imageUrl: 'https://images.unsplash.com/photo-1564419320461-6870880221ad?w=500&q=80', categoryId: '6', menuSection: 'Bebidas', isAvailable: true }
            ]
        },
        {
            id: 'canijo',
            componenttype: 'reservation',
            nameid: 'canijo',
            name: 'Bar Canijo',
            city: 'Algodonales',
            rating: 4.7,
            deliveryTime: 'Reserva',
            deliveryFee: 0,
            imageUrl: 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=800&q=80',
            categories: ['Tradicional', 'Tapas', 'Restaurante'],
            isReservablePartner: true,
            hasDelivery: false,
            categoriesId: ['1'],
            address: 'Plaza de la Constitución, 8, 11680 Algodonales, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Bar+Canijo+Algodonales',
            coordinates: { lat: 36.88081377301815, lng: -5.406407957525807 },
            menu: [
                { id: 'c1', name: 'Solomillo al Whisky', description: 'Clásico solomillo ibérico con salsa al whisky y patatas panaderas.', price: 12.50, imageUrl: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=500&q=80', categoryId: '1', menuSection: 'Carnes', isAvailable: true },
                { id: 'c2', name: 'Croquetas Caseras', description: 'De jamón ibérico, hechas con leche fresca y mucho cariño.', price: 8.00, imageUrl: 'https://i.ytimg.com/vi/ktv5vseGTSY/maxresdefault.jpg', categoryId: '1', menuSection: 'Entrantes', isAvailable: true },
                { id: 'c3', name: 'Ensaladilla Rusa', description: 'La receta de la abuela, con ventresca de atún de primera.', price: 6.50, imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpluhwyxo5SqvWcP_8A0tAc61dDA0xQ7njJQ&s', categoryId: '1', menuSection: 'Entrantes', isAvailable: true },
                { id: 'c4', name: 'Presa Ibérica', description: 'A la brasa con escamas de sal y pimientos de padrón.', price: 16.00, imageUrl: 'https://images.unsplash.com/photo-1558030006-450675393462?w=500&q=80', categoryId: '1', menuSection: 'Carnes', isAvailable: true },
                { id: 'c5', name: 'Caña de Cerveza', description: 'Estrella Galicia bien fría.', price: 1.50, imageUrl: 'https://images.unsplash.com/photo-1535958636474-b021ee887b13?w=500&q=80', categoryId: '1', menuSection: 'Bebidas', isAvailable: true },
                { id: 'c6', name: 'Tarta de Queso', description: 'Casera con mermelada de arándanos.', price: 4.50, imageUrl: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=500&q=80', categoryId: '1', menuSection: 'Postres', isAvailable: true }
            ]
        },
        {
            id: 'anamataliebres',
            componenttype: 'shop',
            nameid: 'anamataliebres',
            name: 'Ana Mataliebres',
            city: 'Algodonales',
            rating: 4.9,
            deliveryTime: '',
            deliveryFee: 0,
            imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT7DTUda1l8eR2xCHw-4bzIMs9awFeCwqQuMg&s',
            categories: ['Gourmet', 'Jamón', 'Tienda'],
            hasDelivery: false,
            categoriesId: ['2'],
            address: 'C. Setenil, 15, 11680 Algodonales, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Ana+Mataliebres+Algodonales',
            coordinates: { lat: 36.8792, lng: -5.4052 },
            menu: [
                { id: 'ana_m1', name: 'Jamón Ibérico de Bellota', description: 'Cortado a cuchillo por expertos. 100g.', price: 18.50, imageUrl: 'https://caprichoiberico.com/wp-content/uploads/2023/11/16457011092381-1024x683.jpeg', categoryId: '2', popular: true, menuSection: 'Charcutería', isAvailable: true },
                { id: 'ana_m2', name: 'Queso Payoyo Curado', description: 'Queso artesano de la Sierra de Grazalema.', price: 24.00, imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpr9CSo_7k6bTMXAtjeiOqb0nKEjj0t63EAA&s', categoryId: '2', menuSection: 'Quesos', isAvailable: true },
                { id: 'ana_m3', name: 'Aceite de Oliva Virgen Extra', description: 'Denominación de Origen Sierra de Cádiz. 500ml.', price: 9.50, imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfPvj2xtJ8a-CfCYInnzCsf3rVgUkYYYVITQ&s', categoryId: '2', menuSection: 'Despensa', isAvailable: true },
                { id: 'ana_m4', name: 'Caña de Lomo Ibérica', description: 'Elaboración tradicional. Pieza de 100g aprox.', price: 12.00, imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbVSOADQoI2HP-3SVRD2Ot1ke6ZK0kh7pukQ&s', categoryId: '2', menuSection: 'Charcutería', isAvailable: true }
            ]
        },
        {
            id: 'pizz1',
            componenttype: 'delivery',
            nameid: 'pizzerialatorre',
            name: 'Pizzeria La Torre',
            city: 'Olvera',
            rating: 4.6,
            deliveryTime: '30-45 min',
            deliveryFee: 2.00,
            imageUrl: 'https://images.unsplash.com/photo-1590947132387-155cc02f3212?w=800&q=80',
            categories: ['Pizza', 'Italiana', 'Cena'],
            hasDelivery: true,
            categoriesId: ['3'],
            address: 'C. Mercado, 3, 11690 Olvera, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Pizzeria+La+Torre+Olvera',
            coordinates: { lat: 36.9325, lng: -5.2535 },
            menu: [
                { id: 'pz1', name: 'Pizza Carbonara', description: 'Nata, bacon, cebolla y extra de mozzarella.', price: 10.50, imageUrl: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=500&q=80', categoryId: '1', popular: true, menuSection: 'Pizzas', isAvailable: true },
                { id: 'pz2', name: 'Pizza Barbacoa', description: 'Salsa barbacoa, carne picada, pollo y bacon.', price: 11.50, imageUrl: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=500&q=80', categoryId: '1', menuSection: 'Pizzas', isAvailable: true },
                { id: 'pz3', name: 'Espaguetis Boloñesa', description: 'Salsa de tomate casera con carne.', price: 9.00, imageUrl: 'https://images.unsplash.com/photo-1622973560614-703d95305953?w=500&q=80', menuSection: 'Pastas', isAvailable: true },
                { id: 'pz4', name: 'Lata Cerveza', description: '33cl.', price: 1.50, imageUrl: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?w=500&q=80', menuSection: 'Bebidas', isAvailable: true }
            ]
        },
        {
            id: 'oil1',
            componenttype: 'shop',
            nameid: 'aceitessierradeolvera',
            name: 'Aceites Sierra de Olvera',
            city: 'Olvera',
            rating: 5.0,
            deliveryTime: 'Recogida',
            deliveryFee: 0,
            imageUrl: 'https://www.remediospicasat.com/wp-content/plugins/funciones/img/productos-varios2.png',
            categories: ['Aceite', 'Gourmet', 'Local'],
            hasDelivery: false,
            categoriesId: ['2'],
            address: 'Polígono Industrial, Nave 4, 11690 Olvera, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Aceites+Sierra+de+Olvera',
            coordinates: { lat: 36.9350, lng: -5.2500 },
            menu: [
                { id: 'ao1', name: 'AOVE Ecológico 5L', description: 'Aceite de oliva virgen extra ecológico. Garrafa 5L.', price: 45.00, imageUrl: 'https://dosbahias.com/wp-content/uploads/2021/03/iliooo.jpg', categoryId: '2', popular: true, menuSection: 'Formatos Grandes', isAvailable: true },
                { id: 'ao2', name: 'Aceite Premium 500ml', description: 'Edición limitada cosecha temprana.', price: 12.00, imageUrl: 'https://www.remediospicasat.com/wp-content/uploads/2018/05/96.jpg', categoryId: '2', menuSection: 'Gourmet', isAvailable: true }
            ]
        },
        {
            id: 'silviajimenez',
            componenttype: 'reservation',
            nameid: 'drasilviajimenezcabeza',
            name: 'Dra. Silvia Jiménez Cabeza',
            city: 'Ronda',
            rating: 5.0,
            deliveryTime: 'Cita Previa',
            deliveryFee: 0,
            imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJVog5DTSq3mgUAt5BHrJDwevhGfUz0R57Xw&s', // Generic pediatrician image
            categories: ['Pediatría', 'Medicina1'],
            hasDelivery: false,
            categoriesId: ['4'], // 'Medicina' category
            address: 'Consulta en Ronda (Cita Previa)',
            googleMapsUrl: '', // No specific physical location for online/home
            isReservablePartner: true, // Uses reservation system for appointments
            coordinates: { lat: 36.7420, lng: -5.1660 },
            menu: [
                {
                    id: 'ped1',
                    name: 'Consulta Online',
                    description: 'Videollamada con la Dra. Silvia Jiménez. Diagnóstico y seguimiento remoto.',
                    price: 40.00,
                    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=500&q=80',
                    categoryId: '4',
                    menuSection: 'Servicios',
                    isReservable: true,
                    isAvailable: true
                },
                {
                    id: 'ped2',
                    name: 'Visita a Domicilio',
                    description: 'Atención pediátrica en la comodidad de tu hogar. Evaluación completa.',
                    price: 80.00,
                    imageUrl: 'https://images.unsplash.com/photo-1584515933487-9d3005c010c7?w=500&q=80',
                    categoryId: '4',
                    menuSection: 'Servicios',
                    isReservable: true,
                    isAvailable: true
                },
                {
                    id: 'ped3',
                    name: 'Consulta de Urgencia',
                    description: 'Atención prioritaria para casos agudos (según disponibilidad).',
                    price: 60.00,
                    imageUrl: 'https://images.unsplash.com/photo-1516574187841-693083f79624?w=500&q=80',
                    categoryId: '4',
                    menuSection: 'Servicios',
                    isReservable: true,
                    isAvailable: true
                }
            ]
        },
        {
            id: 'miyagi1',
            componenttype: 'delivery',
            nameid: 'miyagiexpresssushibar',
            name: 'Miyagi Express Sushi Bar',
            city: 'Ronda',
            rating: 4.8,
            deliveryTime: '30-45 min',
            deliveryFee: 1.50,
            imageUrl: 'https://images.unsplash.com/photo-1553621042-f6e147245754?w=800&q=80',
            categories: ['Sushi', 'Japonesa', 'Asiática'],
            hasDelivery: true,
            isReservablePartner: true,
            categoriesId: ['1', '3'],
            address: 'C. Jerez, 2, 29400 Ronda, Málaga',
            googleMapsUrl: 'https://maps.google.com/?q=Miyagi+Express+Sushi+Bar+Ronda',
            coordinates: { lat: 36.7450, lng: -5.1630 },
            menu: [
                {
                    id: 'mi1',
                    name: 'Uramaki Salmón y Aguacate',
                    description: 'Rollo invertido de arroz con sésamo, relleno de salmón fresco y aguacate. 8 piezas.',
                    price: 10.50,
                    imageUrl: 'https://images.unsplash.com/photo-1617196034603-9688b3cd78f2?w=500&q=80',
                    categoryId: '1',
                    popular: true,
                    menuSection: 'Sushi',
                    isReservable: false,
                    isAvailable: true
                },
                {
                    id: 'mi2',
                    name: 'Nigiri Variado',
                    description: 'Selección de 6 piezas de nigiri (salmón, atún, langostino).',
                    price: 12.00,
                    imageUrl: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=500&q=80',
                    categoryId: '1',
                    menuSection: 'Sushi',
                    isReservable: false,
                    isAvailable: true
                },
                {
                    id: 'mi3',
                    name: 'Gyozas de Pollo',
                    description: 'Empanadillas japonesas rellenas de pollo y verduras, cocinadas al vapor y plancha. 4 unidades.',
                    price: 5.50,
                    imageUrl: 'https://images.unsplash.com/photo-1626804475297-411dbcc75199?w=500&q=80',
                    categoryId: '1',
                    menuSection: 'Entrantes',
                    isReservable: false,
                    isAvailable: true
                },
                {
                    id: 'mi4',
                    name: 'Yakisoba de Verduras',
                    description: 'Fideos salteados con verduras de temporada y salsa yakisoba.',
                    price: 8.90,
                    imageUrl: 'https://images.unsplash.com/photo-1552611052-33e04de081de?w=500&q=80',
                    categoryId: '1',
                    menuSection: 'Platos Calientes',
                    isReservable: false,
                    isAvailable: true
                },
                {
                    id: 'mi5',
                    name: 'Mochi de Té Verde',
                    description: 'Postre tradicional japonés de pastel de arroz.',
                    price: 4.00,
                    imageUrl: 'https://images.unsplash.com/photo-1623689046285-48fa860e0d5a?w=500&q=80',
                    categoryId: '1',
                    menuSection: 'Postres',
                    isReservable: false,
                    isAvailable: true
                },
                {
                    id: 'mi6',
                    name: 'Cerveza Asahi',
                    description: 'Cerveza japonesa premium. 33cl.',
                    price: 3.00,
                    imageUrl: 'https://images.unsplash.com/photo-1606132420790-a7d08b39a3ff?w=500&q=80',
                    categoryId: '1',
                    menuSection: 'Bebidas',
                    isReservable: false,
                    isAvailable: true
                }
            ]
        },
        {
            id: 'fisioterapiacurroramirezcarvajal',
            componenttype: 'reservation',
            nameid: 'fisioterapiacurroramirezcarvajal',
            name: 'Fisioterapia Curro Ramírez Carvajal',
            city: 'Algodonales',
            rating: 4.9,
            deliveryTime: 'Cita Previa',
            deliveryFee: 0,
            imageUrl: 'https://lh3.googleusercontent.com/geougc-cs/ABOP9ptbYkAeWe1C9ydzNVkYNE8Kn-SUPzX_oZ0iL9HL7rAI1Wm3bK9-hDuXUU9h7lIYme4duYqA9P6oYBfHc-m1ZxwdWn1aQY6Y3xpjUlc5ZcLL5c8DcIDuhlWtyj412HOFTKT6Ke8=w321-h242-p',
            categories: ['Fisioterapia', 'Salud', 'Rehabilitación'],
            hasDelivery: false,
            categoriesId: ['4'],
            address: 'C. Real, 10, 11680 Algodonales, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Fisioterapia+Curro+Ramirez+Algodonales',
            isReservablePartner: true,
            coordinates: { lat: 36.8805, lng: -5.4040 },
            menu: [
                {
                    id: 'f1',
                    name: 'Sesión de Fisioterapia',
                    description: 'Tratamiento manual personalizado para dolencias musculares y articulares. 45 min.',
                    price: 35.00,
                    imageUrl: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=500&q=80',
                    categoryId: '4',
                    menuSection: 'Servicios',
                    isReservable: true,
                    isAvailable: true
                },
                {
                    id: 'f2',
                    name: 'Masaje Descontracturante',
                    description: 'Masaje profundo para aliviar tensiones y contracturas.',
                    price: 40.00,
                    imageUrl: 'https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=500&q=80',
                    categoryId: '4',
                    menuSection: 'Servicios',
                    isReservable: true,
                    isAvailable: true
                },
                {
                    id: 'f3',
                    name: 'Rehabilitación Deportiva',
                    description: 'Recuperación de lesiones deportivas y vuelta a la actividad.',
                    price: 45.00,
                    imageUrl: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=500&q=80',
                    categoryId: '4',
                    menuSection: 'Servicios',
                    isReservable: true,
                    isAvailable: true
                }
            ]
        },
        {
            id: 'casarural',
            componenttype: 'booking',
            nameid: 'casaruralelpinsapo',
            name: 'Casa Rural El Pinsapo',
            city: 'Algodonales',
            rating: 4.9,
            deliveryTime: 'N/A',
            deliveryFee: 0,
            imageUrl: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80',
            categories: ['Casa Rural', 'Alquiler Completo', 'Piscina'],
            hasDelivery: false,
            categoriesId: ['5'],
            isReservablePartner: true,
            address: 'Camino de la Sierra, s/n, 11680 Algodonales, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Casa+Rural+El+Pinsapo+Algodonales',
            coordinates: { lat: 36.8830, lng: -5.4020 },
            galleryImages: [
                'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80',
                'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=80',
                'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&q=80',
                'https://www.conilplaya.com/conil-casas/alojamiento-262/casa-conil.jpg',
                'https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&q=80',
                'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&q=80',
                'https://www.conilplaya.com/conil-casas/alojamiento-262/casa-conil.jpg'
            ],
            menu: [
                {
                    id: 'v1',
                    name: 'Alquiler Casa Completa',
                    description: 'Alquiler íntegro de la vivienda. Capacidad para 6 personas. Incluye piscina, barbacoa y wifi.',
                    price: 150.00,
                    imageUrl: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=80',
                    menuSection: 'Alojamiento',
                    isReservable: true,
                    isAvailable: true
                },
                {
                    id: 'v2',
                    name: 'Limpieza Extra',
                    description: 'Servicio de limpieza adicional durante la estancia.',
                    price: 30.00,
                    imageUrl: 'https://images.unsplash.com/photo-1581578731117-104f8fb2935d?w=500&q=80',
                    menuSection: 'Servicios Extra',
                    isAvailable: true
                }
            ]
        },
        {
            id: 'b0eebc99-9c0b-4ef8-bb6d-6bb9bd380b20',
            componenttype: 'base_booking',
            nameid: 'villa-hermanas',
            name: 'Villa Hermanas',
            city: 'Algodonales',
            rating: 4.9,
            reviewCount: 2,
            deliveryTime: 'Estancia mín. 2 noches',
            deliveryFee: 0,
            imageUrl: 'https://img.ruralidays.com/images/rental-homes/large/prop_4295_1895331865.jpg?width=1200&height=630&func=crop&format=jpg',
            categories: ['Casa Rural', 'Alojamiento', 'Piscina Privada', 'Sierra de Cádiz', 'Barbacoa'],
            hasDelivery: false,
            categoriesId: ['5'],
            isReservablePartner: true,
            isFeatured: true,
            address: 'Diseminados km 3.6, 11680 Algodonales, Cádiz',
            googleMapsUrl: 'https://maps.google.com/?q=Villa+Hermanas+Algodonales',
            coordinates: { lat: 36.8725, lng: -5.4215 },
            phone: '605150714',
            whatsappNumber: '605150714',
            openingHours: 'Check-in: a partir de las 16:00 | Check-out: hasta las 11:00',
            reservation_info: 'Villa Hermanas. Casa rural para 5 personas en Algodonales, provincia de Cádiz (VTAR/CA/03376). Cuenta con salón amplio y luminoso con chimenea, cocina americana totalmente equipada, 2 dormitorios (1 matrimonio y 3 individuales) y baño adaptado con ducha. En el exterior cuenta con amplias zonas ajardinadas, piscina privada con tumbonas, barbacoa con cocina exterior y finca vallada en un entorno de máxima tranquilidad.',
            galleryImages: [
                'https://img.ruralidays.com/images/rental-homes/large/prop_4295_1895331865.jpg?width=1600&height=900&func=crop&format=jpg',
                'https://img.ruralidays.com/images/rental-homes/large/prop_4295_1587847664.jpg?width=1600&height=900&func=crop&format=jpg',
                'https://img.ruralidays.com/images/rental-homes/large/prop_4295_1269098276.jpg?width=1600&height=900&func=crop&format=jpg',
                'https://img.ruralidays.com/images/rental-homes/large/prop_4295_640863191.jpg?width=1600&height=900&func=crop&format=jpg',
                'https://img.ruralidays.com/images/rental-homes/large/prop_4295_69843513.jpg?width=1600&height=900&func=crop&format=jpg',
                'https://img.ruralidays.com/images/rental-homes/large/prop_4295_1065562240.jpg?width=1600&height=900&func=crop&format=jpg'
            ],
            menu: [
                {
                    id: 'vh1',
                    name: 'Estancia Villa Hermanas (Alojamiento Completo)',
                    description: 'Alquiler íntegro de la casa rural para hasta 5 personas con piscina privada, barbacoa, 2 dormitorios, chimenea y jardín. VTAR/CA/03376.',
                    price: 157.00,
                    imageUrl: 'https://img.ruralidays.com/images/rental-homes/large/prop_4295_1895331865.jpg?width=800&height=450&func=crop&format=jpg',
                    menuSection: 'Alojamiento Completo',
                    isReservable: true,
                    isAvailable: true
                }
            ]
        }
    ];

    getCategories(): Observable<Category[]> {
        return of(this.categories);
    }

    getPartners(): Observable<Partner[]> {
        return of(this.partners);
    }

    getPartnerById(id: string): Observable<Partner | undefined> {
        return of(this.partners.find(r => r.id === id));
    }

    getPartnerByNameOrId(id: string): Partner | undefined {
        return this.partners.find(p => p.id === id || p.nameid === id);
    }

    getFeaturedPartners(): Observable<Partner[]> {
        return of(this.partners.slice(0, 3)); // Return first 3 as featured
    }

    getMenuItem(partnerId: string, menuItemId: string): { partner: Partner, item: MenuItem } | undefined {
        const partner = this.partners.find(p => p.id === partnerId);
        if (!partner) return undefined;
        const item = partner.menu.find(m => m.id === menuItemId);
        if (!item) return undefined;
        return { partner, item };
    }
}
